import { CardInstrumentComponents } from '../../types';
import { USDContent } from './components/Content';
import { USDTab } from './components/Tab';

export const USD: CardInstrumentComponents = { Content: USDContent, Tab: USDTab };
